import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import DriverModal from '../../components/modals/DriverModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Drivers extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {name: '', license: ''};
    this.state = {redirect: false, drivers: [], filteredDrivers: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getDrivers = this.getDrivers.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getDrivers();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getDrivers() {
    axios.get(`${Configuration.apiServer}/api/v1/drivers`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')
      
      this.setState({drivers: resp.data, filteredDrivers: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/drivers/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getDrivers();
    });
  }

  handleSearch(event) {
    const drivers = this.state.drivers.filter(driver => {
      return driver.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredDrivers: drivers});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/drivers`, {driver: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getDrivers();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/drivers/${this.state.current.id}`, {driver: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getDrivers();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of drivers
    const drivers = this.state.filteredDrivers.map(driver => {
      return (
        <Card
          style={{ width: '24%', margin: '10px 0px' }}
          actions={[<Icon type="eye" style={{ color: '#ccc' }} />, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', driver) }} />]}
          key={driver.id}
        >
          <Meta
            avatar={<Avatar icon="user" />}
            title={driver.name}
            description={<span className={`cursor text-${Configuration.getStatus(driver.status).color}`} onClick={() => { this.handleStatus(driver.id) }}>{Configuration.getStatus(driver.status).text}</span>}
          />
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>Licencia {driver.license}</p>
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>Tel. {driver.phone}</p>
        </Card>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Conductores</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            {drivers}
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <DriverModal visible={this.state.modalVisible} title={"Nuevo conductor"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Drivers;



// WEBPACK FOOTER //
// ./src/pages/admin/Drivers.js